import { pricesBuyMax, pricesBuyMin, pricesRentMax, pricesRentMin } from './prices'
import 'select2/dist/css/select2.css'
import 'select2'
import $ from 'jquery'

export function useHandleFilters() {
    let baseUrl = null;
    let formData = null;
    let urlFilters = [];
    let currentPage = 1;

    const setFormData = (formDataResult) => {
        formData = formDataResult;
    }

    const getUrlFilters = () => {
        return urlFilters;
    }

    const setUrlFilters = (urlFiltersResults) => {
        urlFilters = urlFiltersResults;
    }

    const getCurrentPage = () => {
        return currentPage;
    }

    const setBaseUrl = (url) => {
        baseUrl = url;
    }

    const deselectRadioBtn = (form) => {
        const radioInputs = [
            'input[name="buy_rent"]',
            'input[name="type_object"]',
            'input[name="living_house_type"]',
            'input[name="publication_from"]',
        ];

        radioInputs.forEach((radioInput) => {
            const element = form?.querySelectorAll(radioInput);

            if (element?.length > 0) {
                element.forEach((input) => {
                    input.setAttribute('data-checked', input.checked);

                    input.addEventListener('click', () => {
                        if (input.getAttribute('data-checked') === 'true') {
                            input.checked = false;
                            input.setAttribute('data-checked', false);

                            // Trigger a change event, which normally is not done for deselection
                            let changeEvent = new Event('change', { bubbles: true });
                            input.dispatchEvent(changeEvent);
                        } else {
                            element.forEach((inputReset) => {
                                inputReset.setAttribute('data-checked', false);
                            });
                            input.setAttribute('data-checked', true);
                        }
                    });
                })
            }
        });
    }

    const cleanUrlFilterFormValues = () => {
        const excludedValues = [
            'sorteren',
            'thema',
            'zoeken',
            'kaart'
        ];

        urlFilters = urlFilters.filter((item) => {
            if (!item){
                return;
            }
            const filterParts = item.split('-')
            return excludedValues.includes(filterParts[0])
        });
    }

    const validateInputExists = (element, selectors, multipleInputs = false) => {
        if (element) {
            if (multipleInputs) {
                const input = element.querySelectorAll(selectors);
                if (input) return input;
            } else {
                const input = element.querySelector(selectors)
                if (input) return input;
            }
        }
        return false;
    }

    /**
     * Set value in the form back if it is set in url
     */
    const handlePrefilledInputs = (filters) => {
        const form = document.querySelector('#form-project-filters');

        if (!filters){
            return null;
        }

        const filterEntries = Object.entries(filters)
        if (filterEntries.length > 0) {
            let input = false;

            // Set value in form if is set in url
            filterEntries.forEach(([filterName, filterValue]) => {

                const filterValues = Array.isArray(filterValue) ? filterValue : [filterValue]

                filterValues.forEach((filterValue) => {
                    const filter = filterValue === 1 ? filterName : `${filterName}-${filterValue}`;

                    switch (filterName) {
                        case 'koop':
                            urlFilters.push(filterName);
                            input = validateInputExists(form, 'input[name="buy_rent"][value="koop"]');
                            if (input) input.checked = true;
                            loadBuyPrices(form);
                            break;
                        case 'huur':
                            urlFilters.push(filterName);
                            input = validateInputExists(form, 'input[name="buy_rent"][value="huur"]');
                            if (input) input.checked = true;
                            loadRentPrices(form);
                            break;
                        case 'prijs-min':
                        case 'prijs-max':
                            urlFilters.push(filterName);
                            const priceType = filterName.split('-');
                            input = validateInputExists(form, `select[name="${priceType[1]}_price"]`);
                            if (input) {
                                for (const option of input.options) {
                                    if (option.value === filterValue) {
                                        option.selected = true;
                                        break;
                                    }
                                }
                            }
                            break;
                        case 'actueel':
                        case 'toekomstig':
                        case 'binnenkort':
                        case 'verkocht':
                        case 'verhuurd':
                            if (filterName === 'verhuurd') {
                                filterName = 'verkocht'
                            }
                            urlFilters.push(filterName);
                            input = validateInputExists(form, `input[name="transaction_stage"][value="${filterName}"]`);
                            if (input) input.checked = true;
                            break;
                        case 'woonoppervlakte':
                            urlFilters.push(filter);
                            input = validateInputExists(form, `input[name="living_space"][value="${filterValue}"]`);
                            if (input) input.checked = true;
                            break;
                        case 'perceeloppervlakte':
                            urlFilters.push(filter);
                            input = validateInputExists(form, `input[name="lot_size"][value="${filterValue}"]`);
                            if (input) input.checked = true;
                            break;
                        case 'slaapkamers':
                            urlFilters.push(filter);
                            input = validateInputExists(form, `input[name="bedrooms"][value="${filterValue}"]`);
                            if (input) input.checked = true;
                            break;
                        case 'huis':
                        case 'appartement':
                        case 'kavel':
                            urlFilters.push(filter);
                            input = validateInputExists(form, `input[name="type_object"][value="${filterName}"]`);
                            if (input) input.checked = true;
                            break;
                        case 'woningtype':
                            urlFilters.push(filter);
                            input = validateInputExists(form, `input[name="living_house_type"][value="${filterValue}"]`);
                            if (input) input.checked = true;
                            break;
                        case 'sinds':
                            urlFilters.push(filter);
                            input = validateInputExists(form, `input[name="publication_from"][value="sinds-${filterValue}"]`);
                            if (input) input.checked = true;
                            break;

                        case 'regio':
                        case 'provincie':
                        case 'gemeente':
                        case 'location': // <-- place without prefix is location
                        case 'wijk':
                        case 'buurt':
                            let type = filterName;
                            if (filterName === 'location') {
                                urlFilters.unshift(filterValue);
                                type = 'plaats'
                            } else {
                                urlFilters.push(filter);
                            }

                            input = validateInputExists(form, 'select[name="location"]');
                            if (!input) {
                                return
                            }

                            const capitalizedType = type = type.charAt(0).toUpperCase() + type.slice(1);
                            const place = filterValue.split('-').reduce((acc, word, i) => {
                                if (i > 0){
                                    acc += ' '
                                }
                                return acc + word.charAt(0).toUpperCase() + word.slice(1);
                            }, '')

                            input.innerHTML = `<option value="${filter}" selected="selected">${place} (${capitalizedType})</option>`
                            break;
                        case 'thema':
                            urlFilters.push(filter);
                            break;
                        case 'sorteren':
                            urlFilters.push(filter);
                            input = validateInputExists(document, `input[name="projects_order"][value="${filterValue}"]`);
                            if (input) input.checked = true;
                            break;
                        case 'pagina':
                            urlFilters.push(filter);
                            currentPage = parseInt(filterValue);
                            break;
                        case 'zoeken':
                            if (filterValue.length > 0) {
                                urlFilters.push(filter);
                            }
                            break;
                        case 'kaart':
                            urlFilters.push(filterName);
                            break;
                        case 'geografisch':
                            urlFilters.push(filter);
                            break;
                        case 'nieuwsbrief-inschrijving':
                        case 'digitale-inschrijving':
                        case 'gematchte-projecten':
                        case 'favorieten':
                            urlFilters.push(filterName)
                            break
                        case '':
                            input = validateInputExists(document, `input[name="projects_order"][value="nieuwste"]`);
                            if (input) input.checked = true;
                            break;
                        default:
                            throw new Error(`unimplemented filter ${filterName}`)
                    }
                })
            });
        }
    }

    const handleSubmitFilters = () => {
        let url = baseUrl; // Todo: url make dynamic. Also depends on the routes handling

        if (!url && window.location.pathname.startsWith('/account/projecten')) {
            url = '/account/projecten'
        }

        // Filter empty items
        urlFilters = urlFilters.filter(item => item && item.length > 0);
        // Remove 'location' prefix from filter
        urlFilters = urlFilters.map(item => item.replace('zoeken-', ''))
        if (urlFilters.length > 0) {
            url = `${url}/${urlFilters.join("/")}`;
        }

        // Redirect the page to the constructed URL
        window.location.href = url;
    }

    const handleProjectType = () => {
        const projectType = formData.get('buy_rent');

        urlFilters.push(projectType);
    }

    const handleLocation = () => {
        const value = formData.get('location');
        if (!value){
            return;
        }

        urlFilters = urlFilters.filter(item => item && item.length > 0);
        urlFilters = urlFilters.filter(item => !item.includes('zoeken-'));
        urlFilters.push(`zoeken-${value}`);
    }

    const handleMinPrice = () => {
        const minPrice = formData.get('min_price');
        const projectType = formData.get('buy_rent');

        if (minPrice.length > 0 && projectType) {
            urlFilters.push(`prijs-min-${minPrice}`);
        }
    }

    const handleMaxPrice = () => {
        const maxPrice = formData.get('max_price');
        const projectType = formData.get('buy_rent');

        if (maxPrice.length > 0 && projectType) {
            urlFilters.push(`prijs-max-${maxPrice}`);
        }
    }

    const handleTransactionStage = () => {
        const transactionStages = formData.getAll('transaction_stage');

        if (transactionStages.length > 0) {
            transactionStages.forEach((transactionStage) => {
                urlFilters.push(transactionStage);
            });
        }
    }

    const handleLivingSpace = () => {
        const livingSpaces = formData.getAll('living_space');

        if (livingSpaces.length > 0) {
            livingSpaces.forEach((livingSpace) => {
                urlFilters.push(`woonoppervlakte-${livingSpace}`);
            });
        }
    }

    const handleParcelArea = () => {
        const lotSizes = formData.getAll('lot_size');

        if (lotSizes.length > 0) {
            lotSizes.forEach((lotSize) => {
                urlFilters.push(`perceeloppervlakte-${lotSize}`);
            });
        }
    }

    const handleBedrooms = () => {
        const bedrooms = formData.getAll('bedrooms');

        if (bedrooms.length > 0) {
            bedrooms.forEach((bedroom) => {
                urlFilters.push(`slaapkamers-${bedroom}`);
            });
        }
    }

    const handleTypeObject = () => {
        const typeObject = formData.get('type_object');

        if (typeObject) {
            urlFilters.push(typeObject);
        }
    }

    const handleLivingHouseType = () => {
        const livingHouseType = formData.getAll('living_house_type');
        const typeObject = formData.get('type_object');

        if (livingHouseType.length > 0 && typeObject === 'huis') {
            livingHouseType.forEach((type) => {
                urlFilters.push(`woningtype-${type}`);
            });
        }
    }

    const handlePublicationFrom = () => {
        const publicationFrom = formData.get('publication_from');

        if (publicationFrom) {
            urlFilters.push(publicationFrom);
        }
    }

    const handleAccountFilters = (element) => {
        const accountFilters = element.querySelectorAll('.account-filter__center a')
        const projectAccountFilters = []
        let activeAccountFilter = false

        accountFilters.forEach(link => {
            const slug = link.dataset.slug
            projectAccountFilters.push(slug)

            if (urlFilters.includes(slug)) {
                link.classList.add('is-active')
                activeAccountFilter = slug
            }

            link.addEventListener('click', () => {
                accountFilters.forEach(link => link.classList.add('disabled'))
                urlFilters = urlFilters.filter(item => !projectAccountFilters.includes(item) && item !== `pagina-${currentPage}`)

                if (activeAccountFilter !== slug) {
                    urlFilters.push(slug)
                }

                handleSubmitFilters()
            })
        })
    }

    const handleProjectThemes = (element) => {
        const projectThemes = element.querySelectorAll('.house-filter__center a');
        let activeTheme = false;
        const projectThemeFilters = [];

        projectThemes.forEach(link => {
            const slug = link.getAttribute('data-slug');
            projectThemeFilters.push(`thema-${slug}`);

            if(urlFilters.includes(`thema-${slug}`)){
                link.classList.add('is-active')
                activeTheme = slug;
            }

            link.addEventListener('click', () => {
                projectThemes.forEach(link => link.classList.add('disabled'));
                urlFilters = urlFilters.filter((item) => !projectThemeFilters.includes(item) && item !== `pagina-${currentPage}`);
                // deactivate filter
                if(activeTheme !== slug){
                    urlFilters.push(`thema-${slug}`);
                }
                handleSubmitFilters();
            });
        });
    }

    const handleViewButtons = (element) => {
        const viewButtons = document.querySelectorAll('.house-filter__list a');
        const viewButtonsToggle = document.querySelector('.house-filter__list .toggle');

        viewButtons.forEach(link => {
            // Set 'is-active' class based on current urlFilters
            const button = link.getAttribute('data-slug');
            const isListButton = button === 'list';
            const isMapButton = button === 'map';
            const isMapFilter = urlFilters.includes('kaart');

            if(isMapButton && isMapFilter){
                link.parentElement.classList.add('is-active');
                link.closest('.house-filter__list').querySelector('ul').classList.add(button);
                viewButtonsToggle.dataset.slug = 'list';
            }

            if(isListButton && !isMapFilter){
                link.parentElement.classList.add('is-active');
                link.closest('.house-filter__list').querySelector('ul').classList.add(button);
                viewButtonsToggle.dataset.slug = 'map';
            }

            // Add or remove 'kaart' from urlFilters based on which button is clicked
            link.addEventListener('click', () => {
                if(isListButton && isMapFilter){
                    let index = urlFilters.indexOf('kaart');
                    urlFilters.splice(index,1);
                }
                if(isMapButton && urlFilters.indexOf('kaart') === -1){
                    urlFilters.push('kaart')
                }
                handleSubmitFilters();
            });
        });
    }

    const handleButtonHover = () => {
        const viewButtons = document.querySelectorAll('.house-filter__list li');
        const activeButton = document.querySelector('.house-filter__list li.is-active');

        viewButtons.forEach(button => {
            button.addEventListener('mouseover', function () {
                this.classList.add('is-active');
                var siblings = getSiblings(this);
                siblings.forEach(function (sibling) {
                    sibling.classList.remove('is-active');
                });
            });

            if(button === activeButton){

            }
        });

        viewButtons.forEach(function (button) {
            button.addEventListener('mouseover', function () {
                this.classList.add('is-active');
                let siblings = getSiblings(this);
                siblings.forEach(function (sibling) {
                    sibling.classList.remove('is-active');
                });
            });

            button.addEventListener('mouseout', function () {
                let activeItem = document.querySelector('.house-filter__list li.is-active');
                if (activeItem) {
                    activeItem.classList.remove('is-active');
                    activeButton.classList.add('is-active');
                }
            });
        });

        function getSiblings(element) {
            let siblings = [];
            let sibling = element.parentNode.firstChild;

            while (sibling) {
                if (sibling.nodeType === 1 && sibling !== element) {
                    siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
            }

            return siblings;
        }
    }

    const handleCreateUrlFilters = () => {
        handleProjectType();
        handleLocation();
        handleMinPrice();
        handleMaxPrice();
        handleTransactionStage();
        handleLivingSpace();
        handleParcelArea();
        handleBedrooms();
        handleTypeObject();
        handleLivingHouseType();
        handlePublicationFrom();
    }

    const showLivingHouseType = (form) => {
        if (!form) {
            return
        }

        const inputs = form.querySelectorAll('input[name="type_object"]');
        let selectedRadio = form.querySelector('input[name="type_object"]:checked');
        const livingHouseTypes = form.querySelector('#living-house-type-filters');

        if (selectedRadio && selectedRadio.value === 'huis' && livingHouseTypes) {
            livingHouseTypes.classList.remove("d-none");
            livingHouseTypes.classList.add("d-block");
        }

        inputs.forEach((input) => {
            input.addEventListener('click', () => {
                selectedRadio = form.querySelector('input[name="type_object"]:checked');

                if (selectedRadio && selectedRadio.value === 'huis' && livingHouseTypes) {
                    livingHouseTypes.classList.remove("d-none");
                    livingHouseTypes.classList.add("d-block");
                } else {
                    livingHouseTypes.classList.remove("d-block");
                    livingHouseTypes.classList.add("d-none");
                }
            });
        });
    }

    const showPriceFilter = (form) => {
        if (!form) {
            return
        }

        const inputs = form.querySelectorAll('input[name="buy_rent"]');
        let selectedRadio = form.querySelector('input[name="buy_rent"]:checked');
        const priceFilters = form.querySelector('#price-filter');

        if (selectedRadio && priceFilters) {
            priceFilters.classList.remove("d-none");
            priceFilters.classList.add("d-block");
        }

        inputs.forEach((input) => {
            input.addEventListener('click', () => {
                selectedRadio = form.querySelector('input[name="buy_rent"]:checked');

                if (selectedRadio && priceFilters) {
                    if (selectedRadio.value === 'huur') {
                        loadRentPrices(form);
                    }
                    if (selectedRadio.value === 'koop') {
                        loadBuyPrices(form);
                    }
                    priceFilters.classList.remove("d-none");
                    priceFilters.classList.add("d-block");
                } else {
                    priceFilters.classList.remove("d-block");
                    priceFilters.classList.add("d-none");
                }
            });
        });
    }

    const loadPrices = (form, inputName, optionsData) => {
        const select = form.querySelector(`select[name="${inputName}"]`);

        if (!select) return;

        // Store the first option and remove all other options
        const firstOption = select.options[0];
        while (select.options.length > 1) {
            select.remove(1);
        }
        // Add back the first option
        select.appendChild(firstOption);

        optionsData.forEach(option => {
            const newOption = document.createElement('option');
            newOption.value = option.value;
            newOption.textContent = option.text;
            select.appendChild(newOption);
        });
    }

    const loadRentPrices = (form) => {
        loadPrices(form, 'min_price', pricesRentMin);
        loadPrices(form, 'max_price', pricesRentMax);
    }

    const loadBuyPrices = (form) => {
        loadPrices(form, 'min_price', pricesBuyMin);
        loadPrices(form, 'max_price', pricesBuyMax);
    }

    const handlePriceSelections = (form) => {
        if (!form) {
            return
        }

        const minPriceSelect = form.querySelector('select[name="min_price"]');
        const maxPriceSelect = form.querySelector('select[name="max_price"]');

        if (!minPriceSelect || !maxPriceSelect) {
            return;
        }

        minPriceSelect.addEventListener('change', function () {
            const selectedMinValue = parseInt(minPriceSelect.value, 10);
            const selectedMaxValue = parseInt(maxPriceSelect.value, 10);

            if (selectedMaxValue <= selectedMinValue) {
                maxPriceSelect.selectedIndex = minPriceSelect.selectedIndex + 1;
            }
        });

        maxPriceSelect.addEventListener('change', function () {
            const selectedMinValue = parseInt(minPriceSelect.value, 10);
            const selectedMaxValue = parseInt(maxPriceSelect.value, 10);

            if (selectedMinValue >= selectedMaxValue) {
                minPriceSelect.selectedIndex = maxPriceSelect.selectedIndex - 1;
            }
        });
    }

    const handleDynamicCount = (form) => {
        form?.addEventListener('change', () => {
            setFormData(new FormData(form));
            cleanUrlFilterFormValues();
            handleCreateUrlFilters();

            // Check if urlFilters contains both a location filter and null
            const hasLocation = urlFilters.some(item => typeof item === 'string' && item.startsWith("zoeken-"));
            const hasNull = urlFilters.includes(null);

            // Remove the location filter from urlFilters
            if (hasLocation && hasNull) {
                urlFilters = urlFilters.filter(item => !(typeof item === 'string' && item.startsWith("zoeken-")));
            }

            let newFilters = [];
            if (urlFilters && urlFilters.length > 0) {
                newFilters = urlFilters.map(item => {
                    if (item && typeof item === 'string' && item.startsWith("zoeken-")) {
                        if(!item.includes('gemeente') && !item.includes('regio') && !item.includes('location')){
                            return item.replace("zoeken-", "location-");
                        } else {
                            return item.replace("zoeken-", "");

                        }
                    }
                    return item;
                });
            }

            let filters = '';
            newFilters = newFilters.filter(item => item && item.length > 0);

            if (newFilters.length > 0) {
                filters = `${newFilters.join("/")}`;
            }

            const counter = document.getElementById('js-filter-count');
            if (!counter) {
                return;
            }
            const url = `/api/default/count-projects`;
            const data = {
                filters: filters
            }

            $.ajax({
                url: url,
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function(response) {
                    if (response.count > 1) {
                        counter.textContent = `${response.count} projecten gevonden`;
                    } else if (response.count === 1) {
                        counter.textContent = `${response.count} project gevonden`;
                    } else {
                        counter.textContent = 'Geen projecten gevonden';
                    }
                },
                error: function(error) {
                    console.log(error);
                }
            });
        });
    }

    const handleSubmitForm = (event) => {
        setFormData(new FormData(event.target));
        cleanUrlFilterFormValues();
        handleCreateUrlFilters();
        handleSubmitFilters();
    }

    const initLocationSelect = (form) => {
        if (!form) {
            return
        }

        const select = $('#select-location');
        const placeholder = select.data('placeholder');

        select.select2({
            ajax: {
                url: '/api/bag',
                dataType: 'json',
                delay: 150
            },
            dropdownParent: $('#filter-popup'),
            width: '100%',
            allowClear: true,
            placeholder: placeholder
        });

        // Bubble up the change event to the form, to start the count call.
        let changeEvent = new Event('change', { bubbles: true });
        select
            .on('select2:select', () => form.dispatchEvent(changeEvent))
            .on('select2:unselect', () => form.dispatchEvent(changeEvent))
            .on('select2:clear', () => form.dispatchEvent(changeEvent));
    }

    const init = (element, form) => {
        const filters = JSON.parse(element.dataset.filters) // filters added in data react element as data-filters property, from ProjectFeature.php
        baseUrl = element.dataset.baseUrl // the url without filters

        handlePrefilledInputs(filters);
        deselectRadioBtn(form);
        handleAccountFilters(element)
        handleProjectThemes(element);
        handleViewButtons(element);
        handleButtonHover();
        handleDynamicCount(form);
        showPriceFilter(form);
        handlePriceSelections(form);
        showLivingHouseType(form);
        initLocationSelect(form);
    }

    return {
        init,
        getUrlFilters,
        setUrlFilters,
        getCurrentPage,
        handleSubmitForm,
        handleSubmitFilters,
        handlePrefilledInputs,
        setBaseUrl,
    }
}
